import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ps-panel" }
const _hoisted_2 = { class: "ps-email-block" }
const _hoisted_3 = {
  key: 0,
  class: "ps-email-current"
}
const _hoisted_4 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.4",
  style: {"opacity":".5"}
}
const _hoisted_5 = { class: "ps-email-val" }
const _hoisted_6 = { class: "email-badge" }
const _hoisted_7 = { class: "email-input-row" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "email-error"
}
const _hoisted_11 = { class: "email-hint" }
const _hoisted_12 = { class: "email-input-row" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "email-error"
}
const _hoisted_16 = {
  key: 3,
  class: "email-success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "ps-panel-hd" }, [
      _createElementVNode("h2", null, "E-mail"),
      _createElementVNode("p", null, "Vincule um endereço de e-mail para recuperação de acesso.")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.currentEmail && !_ctx.changingEmail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("rect", {
                x: "2",
                y: "4",
                width: "12",
                height: "8",
                rx: "1.5"
              }, null, -1),
              _createElementVNode("path", {
                d: "M2 5.5l6 4 6-4",
                "stroke-linecap": "round"
              }, null, -1)
            ]))])),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.currentEmail), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('common.verified')), 1),
            _createElementVNode("button", {
              class: "link-btn",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startChangeEmail && _ctx.startChangeEmail(...args)))
            }, _toDisplayString(_ctx.$t('profile.emailChange')), 1)
          ]))
        : (_ctx.emailStep === 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pendingEmail) = $event)),
                  type: "email",
                  placeholder: "seu@email.com",
                  class: "email-input",
                  disabled: _ctx.emailLoading
                }, null, 8, _hoisted_8), [
                  [_vModelText, _ctx.pendingEmail]
                ]),
                _createElementVNode("button", {
                  class: "btn btn-ghost btn-login",
                  type: "button",
                  disabled: _ctx.emailLoading || !_ctx.pendingEmail.trim(),
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendVerificationCode && _ctx.sendVerificationCode(...args)))
                }, _toDisplayString(_ctx.emailLoading ? _ctx.$t('profile.emailSending') : _ctx.$t('profile.emailSendCode')), 9, _hoisted_9)
              ]),
              (_ctx.emailError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.emailError), 1))
                : _createCommentVNode("", true),
              (_ctx.changingEmail)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "link-btn",
                    type: "button",
                    style: {"margin-top":"4px"},
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelChangeEmail && _ctx.cancelChangeEmail(...args)))
                  }, _toDisplayString(_ctx.$t('profile.emailCancelChange')), 1))
                : _createCommentVNode("", true)
            ], 64))
          : (_ctx.emailStep === 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('profile.emailHint', { email: _ctx.pendingEmail })), 1),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.verificationCode) = $event)),
                    type: "text",
                    placeholder: "000000",
                    maxlength: "6",
                    class: "email-input otp-input",
                    disabled: _ctx.emailLoading,
                    inputmode: "numeric"
                  }, null, 8, _hoisted_13), [
                    [_vModelText, _ctx.verificationCode]
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-ghost btn-login",
                    type: "button",
                    disabled: _ctx.emailLoading || _ctx.verificationCode.length < 6,
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.confirmCode && _ctx.confirmCode(...args)))
                  }, _toDisplayString(_ctx.emailLoading ? _ctx.$t('profile.emailVerifying') : _ctx.$t('profile.emailConfirm')), 9, _hoisted_14)
                ]),
                (_ctx.emailError)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.emailError), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "link-btn",
                  type: "button",
                  style: {"margin-top":"4px"},
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.emailStep = 1))
                }, _toDisplayString(_ctx.$t('profile.emailResend')), 1)
              ], 64))
            : (_ctx.emailStep === 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[8] || (_cache[8] = _createElementVNode("svg", {
                    width: "15",
                    height: "15",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "#1f8a45",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('profile.emailSuccess', { email: _ctx.currentEmail })), 1)
                ]))
              : _createCommentVNode("", true)
    ])
  ]))
}